import { render, staticRenderFns } from "./PhotoBookCoverPreview.vue?vue&type=template&id=37b9bc57&scoped=true"
import script from "./PhotoBookCoverPreview.vue?vue&type=script&lang=js"
export * from "./PhotoBookCoverPreview.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookCoverPreview.vue?vue&type=style&index=0&id=37b9bc57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9bc57",
  null
  
)

export default component.exports